import { LegendItem, Task } from 'types/Gantt';

const linearInterpolation = (start: number, end: number, t: number) => {
  return start * (1 - t) + end * t;
};

export const GenerateColorShades = (startColor: string, endColor: string, count: number, opacity: number) => {
  const startR = parseInt(startColor.slice(1, 3), 16);
  const startG = parseInt(startColor.slice(3, 5), 16);
  const startB = parseInt(startColor.slice(5, 7), 16);

  const endR = parseInt(endColor.slice(1, 3), 16);
  const endG = parseInt(endColor.slice(3, 5), 16);
  const endB = parseInt(endColor.slice(5, 7), 16);

  const colorArray = [];

  if (count === 1) {
    const color = `rgba(${startR}, ${startG}, ${startB}, ${opacity})`;
    colorArray.push(color);
    return colorArray;
  }

  for (let i = 0; i < count; i++) {
    const t = i / (count - 1);
    const r = Math.round(linearInterpolation(startR, endR, t));
    const g = Math.round(linearInterpolation(startG, endG, t));
    const b = Math.round(linearInterpolation(startB, endB, t));
    const color = `rgba(${r}, ${g}, ${b}, ${opacity})`;
    colorArray.push(color);
  }

  return colorArray;
};

export const leaveColors = ['#FF6347', '#CD5C5C', '#9B111E', '#FF4500'];

const PALETTE = [
  '#548235',
  '#BF8F00',
  '#4472C4',
  '#C55A11',
  '#7030A0',
  '#C00000',
  '#0070C0',
  '#00B050',
  '#E26B0A',
  '#31859B',
  '#974806',
  '#60497A',
];

export const COLOURS = {
  headerBg: '#449D44',
  headerBgLight: '#5CB85C',
  headerText: '#FFFFFF',
  gridLine: '#B85C8A',
  gridLineDark: '#8A5CB8',
  rowAlt: '#F2F5FA',
  summaryText: '#9D449D',
  border: '#5CB85C',
  today: '#FF0000',
  depArrow: '#000',
  text: '#616161',
  textLight: '#555555',
  textMuted: '#999999',
};

export const assignDynamicColors = (tasks: Partial<Task>[]): { coloredTasks: Task[]; legend: LegendItem[] } => {
  const legendMap = new Map<string, string>();
  let colorIndex = 0;

  const coloredTasks = tasks.map((task) => {
    // Group by primary WBS root (e.g. "1", "2.1", "2.2")
    const outlineParts = (task.outline || '').split('.');
    let rootWBS = outlineParts[0] || '1';
    if (outlineParts.length > 1 && rootWBS !== '1') {
      rootWBS = `${outlineParts[0]}.${outlineParts[1]}`;
    }

    if (!legendMap.has(rootWBS)) {
      legendMap.set(rootWBS, PALETTE[colorIndex % PALETTE.length]);
      colorIndex++;
    }

    return {
      ...task,
      colour: legendMap.get(rootWBS),
    } as Task;
  });

  const legend: LegendItem[] = [];
  legendMap.forEach((colour, wbs) => {
    const summaryTask = tasks.find((t) => t.outline === wbs);
    const label = summaryTask ? summaryTask.name : `Phase ${wbs}`;
    legend.push({ label, colour });
  });

  return { coloredTasks, legend };
};
